<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-section">
        <h3>{{ footerInfo.company_name || '北京佰智康医疗科技有限公司' }}</h3>
        <p>专注医疗健康，呵护全家安康</p>
        <div class="contact-info">
          <p><i class="icon-phone"></i> 联系电话：{{ footerInfo.contact_phone || '15601039626' }}</p>
          <p><i class="icon-email"></i> 电子邮箱：{{ footerInfo.contact_email || '15601039626@163.com' }}</p>
          <p><i class="icon-address"></i> 公司地址：{{ footerInfo.company_address || '北京市海淀区半壁店甲1号院5号楼1层2096室' }}</p>
        </div>
      </div>
      
      <div class="footer-section">
        <h3>快速链接</h3>
        <ul class="footer-links">
          <li><router-link :to="{ name: 'Home' }">首页</router-link></li>
          <li><router-link :to="{ name: 'Products' }">产品中心</router-link></li>
          <li><router-link :to="{ name: 'About' }">关于我们</router-link></li>
          <li><router-link :to="{ name: 'Articles' }">推荐文章</router-link></li>
        </ul>
      </div>
      
      <div class="footer-section">
        <h3>产品分类</h3>
        <ul class="footer-links">
          <li v-if="categoryLoading">加载分类中...</li>
          <li v-else-if="categoryError">加载分类失败</li>
          <li v-else-if="categories.length === 0">暂无分类数据</li>
          <li v-else v-for="category in categories" :key="category.id">
            <router-link :to="{ name: 'Products', query: { category: category.id } }">
              {{ category.name }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    
    <div class="copyright">
      <p>© {{ new Date().getFullYear() }} {{ footerInfo.site_name || '北京佰智康医疗科技有限公司' }} 版权所有 |
        <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-link">
          {{ footerInfo.icp_number || '京ICP备2026014390号-1' }}
        </a>
      </p>
      <p class="medicine-record">
        {{ footerInfo.icp_medicine_number || '(京)网药械信息备字（2026）第 00168 号' }}
      </p>
    </div>
  </footer>
</template>

<script>
import { getMedicineCategories, getFooterInfo } from '@/api/config'

export default {
  name: 'TheFooter',
  data() {
    return {
      categories: [],
      categoryLoading: false,
      categoryError: null,
      footerInfo: {
        site_name: '',
        icp_number: '',
        icp_medicine_number: '',
        company_name: '',
        company_address: '',
        contact_phone: '',
        contact_email: ''
      },
      footerLoading: false,
      footerError: null
    }
  },
  created() {
    this.loadCategories()
    this.loadFooterInfo()
  },
  methods: {
    async loadCategories() {
      this.categoryLoading = true
      this.categoryError = null
      
      try {
        const response = await getMedicineCategories()
        
        if (response.code === 1) {
          this.categories = response.data.sort((a, b) => b.weigh - a.weigh)
        } else {
          this.categoryError = response.msg || '获取分类数据失败'
          console.error('获取分类失败:', this.categoryError)
        }
      } catch (error) {
        console.error('获取分类数据错误:', error)
        this.categoryError = '网络错误，请稍后重试'
      } finally {
        this.categoryLoading = false
      }
    },
    
    async loadFooterInfo() {
      this.footerLoading = true
      this.footerError = null
      
      try {
        const response = await getFooterInfo()
        
        if (response.code === 1) {
          this.footerInfo = response.data
        } else {
          this.footerError = response.msg || '获取底部信息失败'
          console.error('获取底部信息失败:', this.footerError)
        }
      } catch (error) {
        console.error('获取底部信息错误:', error)
        this.footerError = '网络错误，请稍后重试'
      } finally {
        this.footerLoading = false
      }
    }
  }
}
</script>

<style scoped>
/* 底部信息组件样式 */
.footer {
  background-color: #2c3e50;
  color: #ccc;
  padding: 60px 20px 20px;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.footer-section h3 {
  color: white;
  margin-bottom: 20px;
  font-size: 1.3rem;
}

.contact-info p {
  margin-bottom: 10px;
  display: flex;
  align-items: flex-start;
}

.contact-info i {
  min-width: 20px;
  margin-right: 8px;
  text-align: center;
}

.footer-links {
  list-style-type: none;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-links a {
  color: #ccc;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: white;
}

.qr-code {
  text-align: center;
}

.qr-code img {
  width: 120px;
  height: 120px;
  background-color: white;
  padding: 5px;
  border-radius: 4px;
  margin-bottom: 8px;
}

.copyright {
  max-width: 1200px;
  margin: 40px auto 0;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
  font-size: 0.9rem;
  color: #999;
}

.icp-link {
  color: #999;
  text-decoration: none;
  transition: color 0.3s;
}

.icp-link:hover {
  color: #fff;
  text-decoration: underline;
}

.medicine-record {
  margin-top: 6px;
  color: #999;
  font-size: 0.9rem;
}

/* 响应式设计 */
@media (max-width: 576px) {
  .footer-container {
    grid-template-columns: 1fr;
  }
  
  .footer-section {
    margin-bottom: 30px;
  }
}
</style> 